// Stable token values used by USPS address selection radio options.
// Keep these centralized so page state and UI options always match.
export const USER_ENTERED_VALUE = 'user-entered';
export const SUGGESTED_VALUE = 'usps-suggested';
